/* eslint-disable no-redeclare */
import { z } from 'zod';

import {
  FederalPovertyLevel,
  HouseholdIncome,
  HouseholdSize,
  QualifyingLifeEvent,
  UUID,
} from '../primitive';
import { Applicant } from './applicant';
import { Child } from './child';
import { ContactInformation } from './contact';
import { Location } from './location';
import { Spouse } from './spouse';

const ProspectBase = z.object({
  location: Location.optional(),
  householdSize: HouseholdSize.optional(),
  householdIncome: HouseholdIncome.optional(),
  federalPovertyLevel: FederalPovertyLevel.optional(), // FPL
  qualifyingLifeEvent: QualifyingLifeEvent.optional(), // QLE
  applicant: Applicant.optional(),
  spouse: Spouse.optional(),
  children: Child.array().max(4).default([]),
  contactInformation: ContactInformation,
  leadId: UUID.optional(),
  sold: z.boolean(),
});

type ProspectBase = z.infer<typeof ProspectBase>;

function transform(data: ProspectBase) {
  const contactInformation = { ...data.contactInformation };
  const firstName = data.applicant?.firstName;
  const lastName = data.applicant?.lastName;

  if (firstName) {
    contactInformation.firstName = firstName;
  }

  if (lastName) {
    contactInformation.lastName = lastName;
  }

  return {
    ...data,
    contactInformation,
    householdSize:
      data.householdSize ??
      data.children.length + (data.applicant ? 1 : 0) + (data.spouse ? 1 : 0),
  };
}

export const Prospect = ProspectBase.transform(transform);

export type Prospect = z.infer<typeof Prospect>;

export const Lead = ProspectBase.required()
  .partial({
    spouse: true,
  })
  .transform(transform);

export type Lead = z.infer<typeof Lead>;
